// src/components/FloatingNav.jsx
import { FaHome, FaReceipt, FaCashRegister, FaShoppingCart,FaCrown  } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { GiChefToque, GiMeal, GiCook, GiKitchenKnives } from "react-icons/gi";
import { CgMoreO } from "react-icons/cg";


import { getUserdata } from "../../helper/generalHelper";
import { FaBoxOpen, FaQrcode } from "react-icons/fa";

const FloatingNavStaff = () => {
  const location = useLocation();

  // Get user permissions array
  let userPermissions = getUserdata("permissions") || [];
  if (typeof userPermissions === "string") {
    try { userPermissions = JSON.parse(userPermissions); } catch (e) { userPermissions = []; }
  }
  
  const hasPerm = (ids) => {
    if (!ids || ids.length === 0) return true;
    return Array.isArray(userPermissions) && userPermissions.some(p => ids.includes(Number(p)));
  };

  const items = [
    { label: "Dashboard", icon: <FaHome />, to: "/restaurant-staff/employee", perms: [163] },
    { label: "Receipt", icon: <FaReceipt />, to: "/restaurant-staff/employee/receipt", perms: [159] },
    { label: "Counter", icon: <FaCashRegister />, to: "/restaurant-staff/employee/counter", perms: [165] },
    { label: "Orders", icon: <FaShoppingCart />, to: "/restaurant-staff/employee/orders", perms: [167] },
    { label: "KOT", icon: <GiCook  />, to: "/restaurant-staff/employee/kot", perms: [161] },
    { label: "More", icon: <CgMoreO  />, to: "/restaurant-staff/employee/more", perms: [169] }
  ];

  return (
    <div className="hidden md:flex flex-col fixed top-1/2 -translate-y-1/2 right-4 z-50 space-y-4">
      {items.map((item) => {
        if (item.perms && item.perms.length > 0 && !hasPerm(item.perms)) return null;
        
        return (
        <Link
          key={item.to}
          to={item.to}
          className={`bg-rose-600 text-white p-3 rounded-full shadow-lg hover:bg-rose-700 transition-all duration-300 tooltip tooltip-left`}
          data-tip={item.label}
          title={item.label}
        >
          <span className={location.pathname === item.to ? "scale-110" : ""}>
            {item.icon}
          </span>
        </Link>
        );
      })}
    </div>
  );
};

export default FloatingNavStaff;
